import { useCallback } from 'react';
import { useTrackUtmEventMutation } from '@/store/api';
import { getUtmFromStorage } from '@/utils';
import { UtmEventType } from '@sportspredict/shared';

export function useTrackUtmEvent() {
	const [trackMutation] = useTrackUtmEventMutation();

	const trackUtmEvent = useCallback(
		(
			eventType: UtmEventType,
			extra?: { slug?: string; referrer?: string; lobby_id?: string; user_id?: string }
		) => {
			const utm = getUtmFromStorage();
			if (!utm && !extra) return;

			const metadata: Record<string, string> = {};
			if (extra?.slug) metadata.slug = extra.slug;
			if (extra?.referrer) metadata.referrer = extra.referrer;
			if (extra?.lobby_id) metadata.lobby_id = extra.lobby_id;

			trackMutation({
				event_type: eventType,
				user_id: extra?.user_id,
				...utm,
				metadata: Object.keys(metadata).length > 0 ? metadata : undefined,
			});
		},
		[trackMutation]
	);

	return trackUtmEvent;
}
